<template >
  <div class="roleDialog">
    <el-dialog :title="title" :visible.sync="roleDialogVisible">
      <el-form ref="roleForm" :model="roleForm"  label-width="140px" :rules="rules">
        <el-form-item label="角色名称"  class="is-required" prop="name" >
          <el-input v-model.trim="roleForm.name" maxlength="32" placeholder="请输入角色名称..."> </el-input>
        </el-form-item>
        <el-form-item label="排序"  class="is-required" v-if="!this.$props.id" prop="ordinal">
          <el-input v-model.trim="roleForm.ordinal" placeholder="请填写序号..." maxlength="9"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import {Message} from 'element-ui'
export default {
  props: {
    id: {
      type: Number
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '新增角色',
      loading: false,
      roleForm: {
        name: '',
        ordinal: 0
      },
      rules: {
        name: [
          {required: true, message: '请输入用户真实姓名', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请填写序号', trigger: ['blur', 'change']},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 加载页面初始化数据
    loadInitData () {

    },
    save () {
      this.loading = true
      this.$refs.roleForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          this.$refs.roleForm.resetFields()
          this.$emit('success')
          this.loading = false
          this.roleDialogVisible = false
        }
        this.loading = false
      })
    }
  },
  watch: {
    roleDialogVisible (newVal, oldVal) {
      this.title = '新增角色'
      if (newVal && this.$refs.roleForm) {
        this.roleForm = {}
        this.$refs.roleForm.resetFields()
        // 加载初始化数据
        if (this.$props.id) {
          this.loadInitData()
          this.title = '编辑角色'
        }
      }
    }
  },
  computed: {
    roleDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/role-manage/edit-dialog/index.vue